
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.719 2.281L11 9.562V5.999c0-1.103.897-2 2-2h6c1.103 0 2 .897 2 2v12c0 .438-.135.858-.375 1.188l1.406 1.406A3.94 3.94 0 0023 17.999v-4h2v4c0 1.544-.601 2.936-1.563 4l6.281 6.281-1.438 1.438-26-26zM13 6v5.563l6 6V6h-6zm-6 8h2v4c0 2.206 1.794 4 4 4h4.813l1.938 1.938c-.245.031-.496.063-.75.063h-2v2h4v2h-10v-2h4v-2h-2c-3.309 0-6-2.691-6-6v-4zm4 1.188l2 2v.813h.813l2 2H13c-1.103 0-2-.897-2-2v-2.813z"}})])
          )
        }
      }
    